import React, { useState } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useIntl } from 'react-intl';
import { IntlContext } from '../../utility/context/Internationalization';
import API from '../../services/API.redux';
import { applicationActions } from '../../new.redux/actions';
import { store } from '../../redux/storeConfig/store';
import messages_en from '../../assets/data/locales/en.json';
import messages_pt from '../../assets/data/locales/pt.json';
import messages_es from '../../assets/data/locales/es.json';

const languageMessages = {
  en: messages_en,
  pt: messages_pt,
  es: messages_es,
};

const LanguageDropdownMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();

  const languages = [
    { code: 'pt', name: 'PT-BR', fullName: 'Português', flag: '🌐' },
    { code: 'en', name: 'EN', fullName: 'English', flag: '🌐' },
    { code: 'es', name: 'ES', fullName: 'Español', flag: '🌐' },
  ];

  const handleLanguageChange = async (context, languageCode) => {
    try {
      // Buscar language_id do backend
      const languagesResponse = await API()({
        url: '/languages',
        method: 'GET',
      });

      // API.redux retorna response.data || response, então pode vir direto como array
      const languages = Array.isArray(languagesResponse) 
        ? languagesResponse 
        : (languagesResponse?.data || []);

      const selectedLanguage = languages.find(
        (lang) => lang.code === languageCode
      );

      if (selectedLanguage) {
        // Atualizar no backend
        await API()({
          url: '/user',
          method: 'PUT',
          data: { language_id: selectedLanguage.id },
        });

        // Obter mensagens traduzidas do NOVO idioma ANTES de atualizar o contexto
        // Isso garante que usamos as mensagens do idioma selecionado, não do anterior
        const newLanguageMessages = languageMessages[languageCode] || languageMessages['pt'];
        const successTitle = newLanguageMessages['language.update.success.title'] || 'Sucesso';
        const successMessage = newLanguageMessages['language.update.success'] || 'Idioma atualizado com sucesso!';

        // Atualizar no frontend
        context.switchLanguage(languageCode);
        setIsOpen(false);

        // Exibir mensagem no novo idioma
        store.dispatch(
          applicationActions.toggleDialog({
            type: 'success',
            title: successTitle,
            message: successMessage,
            hasTimeout: true,
          })
        );
      }
    } catch (error) {
      console.error('Erro ao atualizar idioma:', error);
      
      // Obter mensagens de erro no idioma atual
      const errorTitle = intl.formatMessage({ id: 'language.update.error.title' });
      const errorMessage = intl.formatMessage({ id: 'language.update.error' });
      
      store.dispatch(
        applicationActions.toggleDialog({
          type: 'error',
          title: errorTitle,
          message: errorMessage,
          hasTimeout: true,
        })
      );
    }
  };

  return (
    <IntlContext.Consumer>
      {(context) => {
        const currentLang = languages.find(
          (lang) => lang.code === context.state.locale
        ) || languages[0];

        return (
          <UncontrolledDropdown
            tag="li"
            className="dropdown-language nav-item"
            isOpen={isOpen}
            toggle={() => setIsOpen(!isOpen)}
          >
            <DropdownToggle tag="a" className="nav-link d-flex align-items-center">
              <span style={{ fontSize: '18px', marginRight: '2px' }}>{currentLang.flag}</span>
              <span>{currentLang.name}</span>
            </DropdownToggle>
            <DropdownMenu right>
              {languages.map((lang) => (
                <DropdownItem
                  key={lang.code}
                  tag="a"
                  onClick={(e) => {
                    e.preventDefault();
                    handleLanguageChange(context, lang.code);
                  }}
                  className={context.state.locale === lang.code ? 'active' : ''}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <span style={{ fontSize: '18px', marginRight: '3px' }}>{lang.flag}</span>
                  <span>{lang.fullName}</span>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      }}
    </IntlContext.Consumer>
  );
};

export default LanguageDropdownMenu;

